/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createProfile = /* GraphQL */ `
  mutation CreateProfile(
    $input: CreateProfileInput!
    $condition: ModelProfileConditionInput
  ) {
    createProfile(input: $input, condition: $condition) {
      id
      userName
      familyName
      givenName
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateProfile = /* GraphQL */ `
  mutation UpdateProfile(
    $input: UpdateProfileInput!
    $condition: ModelProfileConditionInput
  ) {
    updateProfile(input: $input, condition: $condition) {
      id
      userName
      familyName
      givenName
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteProfile = /* GraphQL */ `
  mutation DeleteProfile(
    $input: DeleteProfileInput!
    $condition: ModelProfileConditionInput
  ) {
    deleteProfile(input: $input, condition: $condition) {
      id
      userName
      familyName
      givenName
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createTestExecution = /* GraphQL */ `
  mutation CreateTestExecution(
    $input: CreateTestExecutionInput!
    $condition: ModelTestExecutionConditionInput
  ) {
    createTestExecution(input: $input, condition: $condition) {
      id
      score
      dateTimeStarted
      answers
      TestExecutionStatus
      dateTimeFinished
      durationMinutes
      studentId
      testID
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateTestExecution = /* GraphQL */ `
  mutation UpdateTestExecution(
    $input: UpdateTestExecutionInput!
    $condition: ModelTestExecutionConditionInput
  ) {
    updateTestExecution(input: $input, condition: $condition) {
      id
      score
      dateTimeStarted
      answers
      TestExecutionStatus
      dateTimeFinished
      durationMinutes
      studentId
      testID
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteTestExecution = /* GraphQL */ `
  mutation DeleteTestExecution(
    $input: DeleteTestExecutionInput!
    $condition: ModelTestExecutionConditionInput
  ) {
    deleteTestExecution(input: $input, condition: $condition) {
      id
      score
      dateTimeStarted
      answers
      TestExecutionStatus
      dateTimeFinished
      durationMinutes
      studentId
      testID
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createTest = /* GraphQL */ `
  mutation CreateTest(
    $input: CreateTestInput!
    $condition: ModelTestConditionInput
  ) {
    createTest(input: $input, condition: $condition) {
      id
      Topic
      Grade
      Type
      name
      questions {
        id
        question
        image_name
        possible_answers {
          possibleAnswer
          isCorrect
          explanation
          __typename
        }
        correct_answer
        explanation
        reference
        questionType
        correct_answer_image
        __typename
      }
      durationInMinutes
      numberOfQuestions
      TestExecutions {
        items {
          id
          score
          dateTimeStarted
          answers
          TestExecutionStatus
          dateTimeFinished
          durationMinutes
          studentId
          testID
          createdAt
          updatedAt
          owner
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateTest = /* GraphQL */ `
  mutation UpdateTest(
    $input: UpdateTestInput!
    $condition: ModelTestConditionInput
  ) {
    updateTest(input: $input, condition: $condition) {
      id
      Topic
      Grade
      Type
      name
      questions {
        id
        question
        image_name
        possible_answers {
          possibleAnswer
          isCorrect
          explanation
          __typename
        }
        correct_answer
        explanation
        reference
        questionType
        correct_answer_image
        __typename
      }
      durationInMinutes
      numberOfQuestions
      TestExecutions {
        items {
          id
          score
          dateTimeStarted
          answers
          TestExecutionStatus
          dateTimeFinished
          durationMinutes
          studentId
          testID
          createdAt
          updatedAt
          owner
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteTest = /* GraphQL */ `
  mutation DeleteTest(
    $input: DeleteTestInput!
    $condition: ModelTestConditionInput
  ) {
    deleteTest(input: $input, condition: $condition) {
      id
      Topic
      Grade
      Type
      name
      questions {
        id
        question
        image_name
        possible_answers {
          possibleAnswer
          isCorrect
          explanation
          __typename
        }
        correct_answer
        explanation
        reference
        questionType
        correct_answer_image
        __typename
      }
      durationInMinutes
      numberOfQuestions
      TestExecutions {
        items {
          id
          score
          dateTimeStarted
          answers
          TestExecutionStatus
          dateTimeFinished
          durationMinutes
          studentId
          testID
          createdAt
          updatedAt
          owner
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
